import React from 'react'
import s from './styles/Section.module.scss'
import { useSection } from './hooks/useSection'
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg'

const Section = ({
	title,
	children,
	actions = null,
	missingBtnTitle = '',
	missingBtnOnClick = null,
	className,
	classNameBody,
}) => {
	useSection()
	const hasMissingAction =
		Boolean(missingBtnTitle) && typeof missingBtnOnClick === 'function'

	return (
		<div className={[s.card, className].filter(Boolean).join(' ')}>
			<div className={s.head}>
				<h5 className={s.title}>{title}</h5>
				{actions}
				{hasMissingAction && (
					<button
						type="button"
						className={s.actionBtn}
						onClick={missingBtnOnClick}
					>
						<span className={s.actionBtn__icon}>
							<PlusIcon />
						</span>
						<span className={s.actionBtn__text}>{missingBtnTitle}</span>
					</button>
				)}
			</div>
			<div className={s.body}>{children}</div>
		</div>
	)
}

export default Section
